import { codeImgPlaceholder } from "../../../../src/mdxVars";
import CardExample from "../../../../src/components/docs/examples/Cards";
import CardImage from "../../../../src/components/docs/examples/Cards/CardImage";
import CardGrid from "../../../../src/components/docs/examples/Cards/CardGrid";
import * as React from 'react';
export default {
  codeImgPlaceholder,
  CardExample,
  CardImage,
  CardGrid,
  React
};